import React from 'react';
import { Routes } from './Routes';
import { useHistory } from 'react-router-dom';
import Alerts from 'components/Alerts';
import { SnackbarProvider } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getRepresentantes } from 'services/actions/Autenticacao/AuthService';
import useScripts from 'common/hooks/useScript';
import { userLoggedInActionToken, setUserLogged, setRepresents } from './store/actions/userActions';
import './App.css';
import Loading from 'components/Loading';
import InformloadRequerimentoDialog from 'components/Dialogs/InformloadRequerimentoDialog';
import { showAlert } from 'store/actions/alertsActions';
import { api, sca } from 'services/api';
import { getUser } from 'services/actions/Autenticacao/AuthService';
import AxiosAuthBridge from 'services/AxiosAuthBridge';
import { clearInterceptor, setInterceptor,oidcLogout } from 'services/actions/Autenticacao/AuthService';



const useStyles = makeStyles(() => ({
  base: {
    maxWidth: 600,
    overflowX: 'auto',
    maxHeight: 300
  }
}));

function App() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const { user, represents } = useSelector((store) => {
    return store.userState;
  });

  useScripts('https://kit.fontawesome.com/e10158bc74.js');

  const ListRepresentantes = async (userCpf) => {
    try {
      const representantes = await getRepresentantes(userCpf);
      if (representantes && representantes.length > 0) {
        dispatch(setRepresents(representantes));
      }
    } catch (error) {
      console.error('Erro ao obter representantes:', error);
    }
  };

  React.useEffect(() => {
    const init = async () => {
      const userlogged = await getUser();
      const token = user?.token;

      if (!token) return;

      api.defaults.headers.Authorization = `Bearer ${token}`;
      sca.defaults.headers.Authorization = `Bearer ${token}`;

      if (!user?.token?.length && token) {
        dispatch(userLoggedInActionToken(token));
        dispatch(setUserLogged(true));
      }

      if (user?.userType === '2' && token) {
        if (!represents?.length) {
          ListRepresentantes(user?.userCpf);
        }      
      }
    };
    
    init();
    
  }, [user?.token, user?.userType, represents?.length, dispatch]);

  React.useEffect(() => {
    const interceptorId = api.interceptors.response.use(
      (response) => {
        return {
          data: response?.data?.data || response?.data,
          sucesso: response.sucesso || true
        };
      },
      (error) => {
        let errorMessage = '';
        switch (error.response?.status || 0) {
          case 400:
            errorMessage =
              error.response.data.mensagem ||
              (error.response.data?.reduce &&
                error.response.data.reduce(
                  (a, e) => `${a} ${e.errorMessage}`,
                  ''
                )) ||
              `Ocorreu um erro inesperado. | 400`;
            dispatch(showAlert(errorMessage, 'error'));
            break;

          case 401:
            errorMessage =
              error.response.data.mensagem ||
              (error.response.data?.reduce &&
                error.response.data.reduce(
                  (a, e) => `${a} ${e.errorMessage}`,
                  ''
                )) ||
              `Usuário não autorizado | 401`;
            //oidcLogout();
            dispatch(showAlert(errorMessage, 'error'));
            history.push('/accesso');
            break;

          case 403:
            errorMessage =
              error.response.data.mensagem ||
              (error.response.data?.reduce &&
                error.response.data.reduce(
                  (a, e) => `${a} ${e.errorMessage}`,
                  ''
                )) ||
              `Essa ação é proibida para o usuário | 403`;
            console.error(errorMessage);
            break;

          case 404:
            errorMessage =
              error.response.data || 'Ocorreu um erro inesperado. | 404';
            dispatch(showAlert(errorMessage, 'error'));
            break;

          case 500:
            errorMessage =
              error.response.data.mensagem ||
              (error.response.data?.reduce &&
                error.response.data.reduce((a, e) => a + e.errorMessage, '')) ||
              `Ocorreu um erro inesperado. | 500`;
            dispatch(showAlert(errorMessage, 'error'));
            break;

          default:
            dispatch(
              showAlert(
                `Ocorreu um erro inesperado. | ${error.response?.status || 'Unknown'
                }`,
                'error'
              )
            );
            break;
        }
        return {
          data: null,
          sucesso: false
        };
      }
    );
    setInterceptor(interceptorId);
    
    return () => {
      clearInterceptor();
    };
  }, []);

  // React.useEffect(() => {
  //   return history.listen((location, action) => {
  //     if (action === 'POP') {
        
  //       if (user?.token && (location.pathname === '/acesso' || location.pathname.includes('callback'))) {
  //         // Se ele tá logado e tentou voltar pro login, manda ele pra home dele
  //         history.replace(user.userType === '2' ? '/pagamento' : '/indicadores');
  //       }
  //     }
  //   });
  // }, [history, user]);

  return (
    <SnackbarProvider className={classes.base}>
      <AxiosAuthBridge />
      <Loading />
      <Routes />
      <Alerts />      
      {user?.token && user?.userType === '2' && (
        <InformloadRequerimentoDialog />
      )}
    </SnackbarProvider>
  );
}

export default App;
